import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "../../paginator2/Paginator";
import Loading from "../../common/Loading";
import { searchPropComSales } from "../../../actions/propertyComAction_Dwk";
import { openModal } from "../../../actions/modalAction";

import { Icon } from "semantic-ui-react";
import PropComSummary from "./PropComSummary";

class PropComSaleSearchList extends Component {
  state = {
    pageO: "",
    id: "",
  };
  componentDidMount() {
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    const { limitCS, offsetCS } = this.props;
    this.props.searchPropComSales(values, limitCS, offsetCS);
  }
  handleSearchPropComSale = () => {
    this.props.openModal("SearchModal", { propCS_Dwk: true });
  };

  //*******************************************************

  handleRefresh = () => {
    const { offsetCS, limitCS } = this.props;
    const values =
      (this.props.form !== undefined && this.props.form.values) || {};

    this.props.searchPropComSales(values, limitCS, offsetCS);
  };

  //^^^^^^^^^^^^^^^^^^^^^^^^^
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  //###########################################

  back = () => {
    const { limitCS, offsetCS } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetCS === 0) {
      return;
    }

    this.props.searchPropComSales(values, limitCS, offsetCS - limitCS);
    window.scroll(0, 0);
  };

  advance = () => {
    const { countCS, limitCS, offsetCS } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetCS + limitCS > countCS) {
      return;
    }

    this.props.searchPropComSales(values, limitCS, offsetCS + limitCS);
    window.scroll(0, 0);
  };
  //***************** */

  handleGoToPage2 = (page) => {
    const { limitCS } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };

    this.props.searchPropComSales(values, limitCS, (page - 1) * limitCS);
    window.scroll(0, 0);
  };

  renderLoading = () => {
    if (this.props.fetchingCS === true) {
      return <Loading />;
    }
  };

  render() {
    return (
      <div className="maindiv-820 ">
        <div className="card-attached" style={{ textAlign: "center" }}>
          {/**/}
          <div className="border-heading color-CornflowerBlue flex-center pxy-10">
            <div style={{ flex: "15%" }} onClick={this.handleSearchPropComSale}>
              <span className="tag-button">
                {" "}
                <Icon name="search" />
              </span>
            </div>

            <div
              style={{ display: "flex", flex: "80%", justifyContent: "center" }}
            >
              <div className="font-20B ml-05 color-head-prop">
                {this.props.countCS} Commercial Property For Sale in{" "}
                {this.props.city}
              </div>
            </div>
          </div>
          {/**/}
        </div>
        {/*  */}

        <div>
          {this.renderLoading()}

          {this.props.propcomsCS.map((item) => (
            <PropComSummary
              handleRefresh={this.handleRefresh}
              key={item._id}
              propcom={item}
            />
          ))}
        </div>

        <div className="card-attached flex-center ">
          {this.props.propcomsCS !== undefined &&
            this.props.propcomsCS.length && (
              <Pagination
                changePage={this.handleGoToPage2}
                advance={this.advance}
                back={this.back}
                page={
                  this.props.offsetCS === 0
                    ? 1
                    : Math.ceil(this.props.offsetCS / this.props.limitCS + 1)
                }
                pages={Math.ceil(this.props.countCS / this.props.limitCS)}
              />
            )}
        </div>
        {/*  */}

        <br />
        <br />
      </div>
    );

    //@@@@
  }
}

const mapStateToProps = ({ dwk_com_property, auth, form }) => {
  const { city, fetchingCS, limitCS, offsetCS, countCS } = dwk_com_property;

  return {
    city,
    fetchingCS,
    limitCS,
    offsetCS,
    countCS,
    form: form.PropComSaleSearch,
    propcomsCS: dwk_com_property.propcomsCS,
    userA: auth.userA,
  };
};

export default connect(mapStateToProps, { searchPropComSales, openModal })(
  PropComSaleSearchList
);
